export const getCssTag = (query) => {
  return window
    .getComputedStyle(window.document.querySelector(query), ":after")
    .getPropertyValue("content")
    .replace(/"|'/g, "")
}
